import { render, staticRenderFns } from "./Comunicaciones.vue?vue&type=template&id=2788eb22&scoped=true"
import script from "./Comunicaciones.vue?vue&type=script&lang=js"
export * from "./Comunicaciones.vue?vue&type=script&lang=js"
import style0 from "./Comunicaciones.vue?vue&type=style&index=0&id=2788eb22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2788eb22",
  null
  
)

export default component.exports